import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
const verIcon = require("assets/img/icons/ver.png");
const eliminarIcon = require("assets/img/icons/borrar.png");
const editarIcon = require("assets/img/icons/editar.png");
const reabrirIcon = require("assets/img/icons/refresh.png");

export const HistoricoTable = ({
    inventarios,
    EliminarHistoricoInventario,
    ReabrirHistoricoInventario,
}) => {
    return (
        <div className="new-table-wrapper historico-inventarios__table-wrapper">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>ID Inventario</th>
                        <th>Fecha Inicial</th>
                        <th>Fecha Final</th>
                        <th>Almacenes inventariados</th>
                        <th>Usuario</th>
                        <th>Estado</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {inventarios.length === 0 && (
                        <tr>
                            <td colSpan={7} className="text-center">
                                No hay registros de inventario
                            </td>
                        </tr>
                    )}
                    {inventarios.map((item) => {
                        const estaCerrado = item.estado === "CERRADO";

                        return (
                            <tr key={item.id}>
                                <td className="text-center">{item.id}</td>
                                <td className="text-center text-nowrap">
                                    {item.fecha_inicial
                                        ? moment(item.fecha_inicial).format(
                                              "DD/MM/YYYY",
                                          )
                                        : "N/A"}
                                </td>
                                <td className="text-center text-nowrap">
                                    {/* restar 1 día a la fecha final */}
                                    {item.fecha_final
                                        ? moment(item.fecha_final)
                                              .subtract(1, "day")
                                              .format("DD/MM/YYYY")
                                        : "N/A"}
                                </td>
                                <td className="text-center text-nowrap historico-inventarios__table-ellipsis-cell">
                                    {item.almacenes && item.almacenes.length > 0
                                        ? item.almacenes.join(", ")
                                        : "N/A"}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.usuario}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.estado}
                                </td>
                                <td>
                                    <div className="table-actions">
                                        <Link
                                            to={`/inventarios-almacen/almacenes/${item.id}`}
                                        >
                                            {estaCerrado ? (
                                                <img
                                                    src={verIcon}
                                                    alt="Ver"
                                                    className="action_img"
                                                    title="Ver"
                                                />
                                            ) : (
                                                <img
                                                    src={editarIcon}
                                                    alt="Editar"
                                                    className="action_img"
                                                    title="Editar"
                                                />
                                            )}
                                        </Link>
                                        {estaCerrado && item.es_ultimo && (
                                            <img
                                                src={reabrirIcon}
                                                alt="Reabrir"
                                                className="action_img"
                                                title="Reabrir"
                                                onClick={() =>
                                                    ReabrirHistoricoInventario(
                                                        item.id,
                                                    )
                                                }
                                            />
                                        )}
                                        {!estaCerrado && (
                                            <img
                                                src={eliminarIcon}
                                                alt="Eliminar"
                                                className="action_img"
                                                title="Eliminar"
                                                onClick={() =>
                                                    EliminarHistoricoInventario(
                                                        item.id,
                                                    )
                                                }
                                            />
                                        )}
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
